import React from 'react';

const Us1_ele_tec = () => {
  return (
    <div>
      
    </div>
  );
}

export default Us1_ele_tec;
